import * as yup from 'yup';
import _ from 'lodash';
import JobModel from '../../models/model';
import CloseJobModel from '../../models/closeJobModel';
import ApplicantModel from '../../models/applicantModel';
import getSchema from '../schema';

const emptyValues = {
  string: '',
  bool: false,
  object: {},
  array: [],
  number: '',
  date: '',
};

const defaultValues = _.mapValues(
  JobModel,
  ({ validationType }) => emptyValues[validationType]
);

const defaultJobCloseValues = _.mapValues(
  CloseJobModel,
  ({ validationType }) => emptyValues[validationType]
);

const defaultJobApplicantValues = _.mapValues(
  ApplicantModel,
  ({ validationType }) => emptyValues[validationType]
);

const getAddSchema = (model) => {
  const yupSchema = getSchema(model);
  return yup.object().shape(yupSchema);
};
const schema = getAddSchema(JobModel);

export {
  getAddSchema,
  defaultValues,
  defaultJobCloseValues,
  defaultJobApplicantValues,
};

export default schema;
